import React from 'react';
import {
  columnValue,
  columnName,
  columnTools,
  columnCategory,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';

const VocabulariesTableColumns = ({
  columns = [columnName, columnValue, columnTools, columnCategory],
}) => (
  <NameDescriptionColumns columns={columns}>
    {hasColumn(columns, columnCategory) && (<UnsortedColumn columnId={columnCategory} />)}
    {hasColumn(columns, columnValue) && (<UnsortedColumn columnId={columnValue} />)}
  </NameDescriptionColumns>
);

export default VocabulariesTableColumns;
